import { render, staticRenderFns } from "./PageTopbar.vue?vue&type=template&id=0f1e1e10"
import script from "./PageTopbar.vue?vue&type=script&lang=js"
export * from "./PageTopbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports